import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { languages } from "../../assets/locals";
import environment from "../../environment";
import breakpoints from "../../constants/breakpoints";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router-dom";
import PathConstants from "../../routes/pathConstants";
import { getAllLanguages } from "../../services/translation/translation.service";
const Styles = styled.div`
  height: 30px;
  font-weight: 500;
  .lang-list {
    .lang-item {
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 5px;
      @media (max-width: ${breakpoints.ipadPro}) {
        justify-content: start;
      }

      ${({ isAR }) => !isAR && " align-items: center;"};
    }

    text-align: end;
    svg {
      width: 24px;
      height: 24px;
      object-fit: cover;
      cursor: pointer;
      color: var(--white) !important;
    }
    span {
      font-size: 16px;
      cursor: pointer;
      color: var(--white) !important;
      border-radius: var(--border-radius);
    }
  }

  .lang-list:hover .sub-lang-menu {
    transition: 0.5s;
    opacity: 1;
    visibility: visible;
    transform: scaleY(1) translateX(10px);
    z-index: 10000;
  }
  .lang-list:hover .sub-lang-menu.sub-lang-menu-en {
    transform: scaleY(1) translateX(-10px);
  }
  .sub-lang-menu {
    position: absolute;
    background: var(--white);
    margin: 0;
    margin-top: 6px;
    z-index: 9999;
    box-shadow: 0px 1px 3px rgb(0, 0, 0, 0.3);
    opacity: 0;
    transform-origin: 0 0;
    transform: scaleY(0) translateX(10px);
    visibility: hidden;
    transition: all 0.3s ease-in-out;
    z-index: 10000;
    border-radius: 100px;

    .lang-item {
      font-family: "inter" !important;
      padding: 0.5rem 1rem;
      list-style: none;
      cursor: pointer;
      border-radius: 100px;
      button {
        background: none;
        border: 0px;
        color: var(--black);
        transition: all 0.3s ease;
      }
      &:hover {
        background-color: var(--main-color);
        button {
          color: white;
        }
      }
    }
  }
  .sub-lang-menu.sub-lang-menu-en {
    transform: scaleY(0) translateX(-10px);
  }
  @media (max-width: ${breakpoints.lg}) {
    .lang-list img {
      margin: 0 0.5rem;
    }
  }
  @media (max-width: ${breakpoints.md}) {
    ${({ isAR }) => (isAR ? "padding-right: 0rem;" : "padding-left: 0rem;")};
  }
  @media (max-width: ${breakpoints.sm}) {
    padding: 0 20px;
    .lang-list {
      text-align: start;
      img {
        filter: invert(31%) sepia(9%) saturate(0%) hue-rotate(136deg)
          brightness(103%) contrast(83%);
      }
    }
    .sub-lang-menu {
      /* width: 60%; */
      text-align: center;
      .lang-item {
      }
    }
  }
`;
const LangugaeSwitcher = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const lang = i18n.language;
  const location = useLocation();
  const isHomePage = location.pathname === PathConstants.HOME;

  const refreshPage = () => {
    navigate(0);
  };
  const [isLanguagesLoading, setIsLanguagesLoading] = useState(false);
  // const [languages, setLanguages] = useState([]);
  // const getLanguages = async () => {
  //   setIsLanguagesLoading(true);
  //   const response = await getAllLanguages();
  //   if (response?.status === 200) {
  //     setLanguages(response?.data?.data)
  //   }
  //   setIsLanguagesLoading(false);
  // };

  // useEffect(() => {

  //   getLanguages();

  // }, []);

  return (
    <Styles isHomePage={isHomePage} isAR={lang === "ar"}>
      <div className="lang-list">
        <div className="lang-item">
          <span>{lang === "ar" ? "عربي" : lang === "en" && "EN"}</span>
          <MdOutlineKeyboardArrowDown />
        </div>
        <ul
          className={
            i18n?.language === "ar"
              ? "sub-lang-menu p-0"
              : "sub-lang-menu sub-lang-menu-ltr p-0"
          }
        >
          {languages?.map(
            (lang, index) =>
              lang.key !== i18n?.language && (
                <li key={index} className="lang-item">
                  <button
                    onClick={() => {
                      Cookies.set(environment?.localLang, lang.key);
                      localStorage.setItem(environment?.lang, lang.key);
                      i18n.changeLanguage(lang.key);
                      refreshPage();
                      // window.location.reload();
                    }}
                  >
                    {lang.label}
                  </button>
                </li>
              )
          )}
        </ul>
      </div>
    </Styles>
  );
};

export default LangugaeSwitcher;
